var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRegenerate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 13C11.7614 13 14 10.7614 14 8C14 5.23858 11.7614 3 9 3C6.23858 3 4 5.23858 4 8H5.351C5.90751 8 6.20494 8.65837 5.83847 9.07904L3.48747 11.7778C3.22941 12.0741 2.77059 12.0741 2.51253 11.7778L0.161525 9.07904C-0.204938 8.65837 0.0924892 8 0.648998 8H2C2 4.13401 5.13401 1 9 1C12.866 1 16 4.13401 16 8C16 11.866 12.866 15 9 15C8.12206 15 7.28187 14.8384 6.50756 14.5433C5.90645 14.3142 5.78615 13.5599 6.20694 13.0733C6.51854 12.713 7.03291 12.623 7.48699 12.767C7.96428 12.9183 8.47261 13 9 13Z",
    fill: "#2C2D2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegenerate);
export default __webpack_public_path__ + "static/media/regenerate.22ec29fd1f1ff53bfc950adf0e0bd879.svg";
export { ForwardRef as ReactComponent };